// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { AllPermissionsGuard } from 'src/app/shared/guards/all-permissions.guard';
import { ArchiveV3RedirectGuard } from 'src/app/shared/guards/archive-v3-redirect.guard';
import { RoleGuard } from 'src/app/shared/guards/role.guard';
import { UnsavedChangesGuard } from 'src/app/shared/guards/unsaved-changes.guard';
import { ARCHIVE_V3_SETTINGS_DOCUMENTS } from 'src/app/shared/utils/archive-v3-redirect.utils';

// Custom packages - Component
import { DataTypesComponent } from 'src/app/modules/settings/pages/data-types/data-types.page';
import { DocumentDetailComponent } from 'src/app/modules/settings/pages/document-detail/document-detail.page';
import { DocumentTemplateComponent } from 'src/app/modules/settings/pages/document-template/document-template.page';
import { StructureDetailComponent } from 'src/app/modules/settings/pages/structure-detail/structure-detail.page';

const routes: Routes = [
  {
    path: 'structure-detail',
    component: StructureDetailComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canCreateSettings']
    },
  },
  {
    // The editor of the old taxonomy: once the 3.0.0 archive is live its address opens the editor of
    // the new one (FEX-27), since the back-end refuses its saves (410) with the old archive off
    path: 'document-detail',
    component: DocumentDetailComponent,
    canActivate: [ArchiveV3RedirectGuard, RoleGuard],
    data: {
      permissions: ['canCreateSettings'],
      archiveV3Redirect: ARCHIVE_V3_SETTINGS_DOCUMENTS,
    },
  },
  {
    // Document archive backed by the three-collections API
    // (/api/v2/document-template). Lives side by side with 'document-detail'
    // until the cutover is decided.
    path: 'document-template',
    component: DocumentTemplateComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canCreateSettings']
    },
  },
  {
    // Data types catalogue: the CRUD of the forms shown when a document is archived.
    // Guarded with AllPermissionsGuard, NOT RoleGuard: the back-end protects every
    // route of /api/v2/data-types with an AND of the two permissions, so the OR guard
    // would let a half authorised user in front of a page answering 403 on every call.
    path: 'data-types',
    component: DataTypesComponent,
    canActivate: [AllPermissionsGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      permissions: ['canReadDocumentsList', 'canCreateSettings']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class SettingsRoutingModule { }
